import BaseInputDate from "./BaseInputDate.vue";

export * from "./BaseInputDate.vue";
export default BaseInputDate;
